import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Grid,
  Box,
  Typography,
  LinearProgress,
  FormControl,
  Select,
  MenuItem,
  Backdrop,
  Button,
  CircularProgress,
  Checkbox,
  TextField,
  Divider,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import { useMsal } from '@azure/msal-react';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useGoogleLogin } from '@react-oauth/google';
import { ReactComponent as Tally } from '../../../../assets/common-assets/tally.svg';
import {
  API_KEY,
  exportQB,
  SETTING,
} from '../../../../constants/staticContent';
import {
  CustomFormControl,
  CustomMenuItem,
  MenuItemBox,
  Root,
  SelectDuplicateDocumentMenu,
  SelectKeyMenu,
  SelectTagAutoComplete,
  classes,
} from './utils';
import { lightPalette } from '../../../../theme';
import {
  deleteCredential,
  // deleteCredential,
  deleteKeys,
  getCredentialsById,
  getSecretKey,
  listOfApiKeys,
  listOfCredentials,
  updateClient,
  updateIsDownloadStatus,
} from '../../../../services/apiKey';
import {
  modelSelectDropBox,
  postModelName,
  updateDocumentDetailsDuplication,
  updateDocumentDuplication,
  updateManagersFCStatus,
} from '../../../../services/accountSetting';
import { getLocalStorageItem } from '../../../../services/localStorageUtils';
import ROLES from '../../../../constants/roles';
import CustomTooltip from '../../utils/CustomTooltip';
import KeyNameForm from './api-keys/KeyNameForm';
import Toast from '../../utils/Toast';
import ConfirmDialog from '../../utils/ConfirmDialog';
import { getMemberById } from '../../../../services/userApi';
import DataFields from './DataFields';
import { getManagers } from '../../../../services/billingInfo';
import DynamicTabLayout from './TabLayout';
import { ReactComponent as GoogleDriveIcon } from '../../../../assets/uploadFile-assets/google-drive.svg';
import { ReactComponent as OneDriveIcon } from '../../../../assets/uploadFile-assets/one-drive.svg';
import { ReactComponent as SharePointIcon } from '../../../../assets/uploadFile-assets/sharepoint.svg';
import { ReactComponent as GmailIcon } from '../../../../assets/uploadFile-assets/gmail.svg';
import { ReactComponent as OutlookIcon } from '../../../../assets/uploadFile-assets/outlook.svg';
import { ReactComponent as Zoho } from '../../../../assets/common-assets/zoho.svg';
import { ReactComponent as Xero } from '../../../../assets/common-assets/xero.svg';
import { ReactComponent as Odoo } from '../../../../assets/common-assets/odoo.svg';
import { ReactComponent as QuickBook } from '../../../../assets/common-assets/quickBook.svg';
import CardComponent from './CardComponent';
import TallyPrimeForm from '../flow-configuration/TallyPrimeForm';
import OdooForm from '../flow-configuration/OdooForm';
import {
  tokenExchange,
  tokenExchangeForXero,
  xeroAuthentication,
  zohoAuthentication,
} from '../../../../services/flowConfiguration';
import {
  QB_CLIENT_ID,
  THIRD_PARTY_REDIRECT_URL_URL_FOR_MANUAL_SETTINGS,
} from '../../../../constants/Constants';
import {
  createManualAuthCredential,
  tokenExchangeForQB,
} from '../../../../services/exportApi';
import TaxMapping from '../flow-configuration/TaxMapping';
import getAllGoogleToken from '../../../../services/authenticationApi';
import { openAuthenticationEmailPicker } from '../flow-configuration/oneDriveAutomationFlow';
import googleDriveFolderPath from '../flow-configuration/googleDriveFolderPath';
import DisplayNamePopUp from '../documents/DisplayNamePopUp';

const duplicateDocumentMenuItems = ['Keep', 'Reject'];
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const TabData = [
  {
    label: 'General',
  },
  {
    label: 'Credentials',
  },
  {
    label: 'Data Field',
  },
];
const tabs = [
  { value: '1', label: 'Sales' },
  { value: '2', label: 'Direct Expenses' },
  { value: '3', label: 'Indirect Expenses' },
  { value: '4', label: 'Bank Statement' },
  { value: '5', label: 'Credit Card Statement' },
];

const CredentialSideBarMenu = [
  // {

  //   label: 'Gmail',

  // },
  // {
  //   label: 'One Drive',
  // },
  // {
  //   label: 'Google Drive',
  // },
  // {

  //   label: 'Outlook',

  // },
  // {

  //   label: 'SharePoint',

  // },
  {
    label: 'Tally Prime',
  },
  {
    label: 'Odoo',
  },
  {
    label: 'Zoho',
  },
  {
    label: 'QuickBook',
  },
  {
    label: 'Xero',
  },
];

const Setting = () => {
  const StyledMenuProps = {
    PaperProps: {
      sx: {
        maxHeight: 200,
      },
    },
  };
  const [model, setModelName] = useState([{ short_desc: 'gemini' }]);
  const [selectedModel, setSelectedModel] = useState('gemini');

  const [openKeyNameForm, setOpenKeyNameForm] = useState(false);
  const [apiResponseData, setApiResponseData] = useState(null);
  const [apiKeyList, setApiKeyList] = useState([]);
  const [selectedApiKey, setSelectedApiKey] = useState('');
  const [credentials, setCredentials] = useState([]);

  // Document Handling
  const [duplicateDocument, setDuplicateDocument] = useState('');
  const [duplicateDocumentDetails, setDuplicateDocumentDetails] = useState('');

  const [isOpen, setIsOpen] = useState(false);
  const [payment, setPayment] = useState({});
  const [expiryDate, setExpiryDate] = useState('');
  const [showTooltip, setShowTooltip] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [managers, setManagers] = useState([]);
  const [selectedManagers, setSelectedManagers] = useState([]);
  const [selectedCredential, setSelectedCredential] = useState([]);
  const [selectedTab, setSelectedTab] = useState('TallyPrime');
  const [currentParentTab, setCurrentParentTab] = useState('general');
  const [isOpenCredentialPopup, setIsCredentialPopup] = useState('');
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const states = urlParams.get('state');
  const realmId = urlParams.get('realmId');
  const exportOptionFromSessionStorage = sessionStorage.getItem('exportOption');
  const [openTaxPopup, setOpenTaxPopup] = useState(false);
  const [credentialId, setCredentialId] = useState();
  const [credentialData, setCredentialData] = useState();
  const [exportType, setExportType] = useState();
  const [currentData, setCurrentData] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const userDetail = useSelector((state) => state.user.user);
  const navigate = useNavigate();
  const isSetting = true;
  const isManual = true;
  const [openDisplayNamePopup, setOpenDisplayNamePopup] = useState(false);
  const [displayName, setDisplayName] = useState('');
  const [displayNameRequiredError, setDisplayNameRequiredError] = useState('');
  const displayNameFromSessionStorage = sessionStorage.getItem(
    'displayNameForCredential',
  );

  const handleDisplayNamePopupClose = () => {
    setOpenDisplayNamePopup(false);
    setDisplayNameRequiredError('');
  };

  const addAccountDisplayName = () => {
    setDisplayName('');
    setOpenDisplayNamePopup(true);
  };

  const role = getLocalStorageItem('role');
  const isTabVertial = true;
  const getManagerList = async () => {
    const res = await getManagers();
    if (res?.data?.response) {
      const managerData = res.data.response.map((elem) => ({
        title: `${elem.first_name} ${elem.last_name}`,
        id: elem.id,
        isFc: elem.is_fc,
      }));
      const defaultSelected = managerData.filter((manager) => manager.isFc);
      setSelectedManagers(defaultSelected);
      setManagers(managerData);
    }
  };

  useEffect(() => {
    if (userDetail && Object.keys(userDetail).length !== 0) {
      getManagerList();
    }
  }, [userDetail]);

  const handleSelectionChange = async (event, newValue) => {
    setSelectedManagers(newValue);
    const selectedManagersUUID = newValue.map((item) => item.id);
    await updateManagersFCStatus(selectedManagersUUID);
  };

  // const handleCredentialSelectionChange = async (event, newValue) => {
  //   setSelectedCredential(newValue);
  //   setIsCredentialPopup(true);
  // };

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;
      setShowTooltip(windowWidth >= 600 && windowWidth <= 900);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (role !== ROLES.MEMBER) {
          const listData = await modelSelectDropBox();

          if (listData?.length >= 0) {
            setIsLoading(false);
            setModelName(listData);
          }
        }
      } catch (error) {
        return error;
      }
    };

    const fetchLoggedInUser = async () => {
      const nameMerge = `${userDetail?.first_name} ${userDetail?.last_name}`;
      const accountName = userDetail ? nameMerge : 'Name';
      const accountEmail = userDetail ? userDetail?.email : 'Email';
      setName(accountName);
      setEmail(accountEmail);
      setSelectedModel(userDetail?.organization?.tenant_setting?.model_type);
      setDuplicateDocument(
        userDetail?.organization?.tenant_setting?.duplication,
      );
      setDuplicateDocumentDetails(
        userDetail?.organization?.tenant_setting?.duplication_details,
      );
      if (role !== ROLES.SUPER_ADMIN) {
        setPayment(userDetail?.organization);
        const expiryDateOfPayment = new Date(
          userDetail?.organization?.payment[0]?.end_date,
        ).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        });
        setExpiryDate(
          userDetail?.organization?.payment.length > 0
            ? ` ${expiryDateOfPayment}`
            : ' --',
        );
        if (role === ROLES.MEMBER) {
          setIsLoading(false);
        }
      }
    };

    if (userDetail && Object.keys(userDetail).length !== 0) {
      fetchLoggedInUser();
      fetchData();
    }
  }, [role, userDetail]);

  useEffect(() => {
    const fetchApiKeyList = async () => {
      if (role !== ROLES.MEMBER) {
        const response = await listOfApiKeys();
        setApiKeyList(response?.allKeys);
      }
    };
    fetchApiKeyList();
  }, [apiResponseData]);

  const getCredentials = async () => {
    const response = await listOfCredentials(userDetail.id);
    setCredentials(response.credential);
  };

  useEffect(() => {
    if (Object.keys(userDetail).length !== 0) {
      getCredentials();
    }
  }, [userDetail, isOpenCredentialPopup]);
  useEffect(() => {
    if (currentParentTab === 'credentials') {
      if (selectedTab && credentials.length > 0) {
        const selectedTabCredential = credentials.filter(
          (ele) => ele.type === selectedTab,
        );
        setSelectedCredential(selectedTabCredential);
      }
    }
  }, [selectedTab, credentials, currentParentTab, isOpenCredentialPopup]);
  const handleDeleteCredential = async (id, selectedType) => {
    try {
      await deleteCredential(id);
      const updatedCredentials = await listOfCredentials(userDetail.id);
      setCredentials(updatedCredentials.credential); // Update state with the new credentials
      setSelectedTab(selectedType);
    } catch {
      Toast({ message: 'Error deleting credential', variant: 'error' });
    }
  };

  const handleModel = async (event) => {
    setSelectedModel(event.target.value);
    await postModelName(event.target.value);
  };

  const handleChange = (newValue) => {
    if (newValue === 'quickbook') {
      setSelectedTab('QuickBook');
    } else if (newValue === 'sharepoint') {
      setSelectedTab('SharePoint');
    } else if (newValue && newValue.length) {
      const output = newValue
        .split('-') // Split by the hyphen
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');
      setSelectedTab(output);
    }
  };

  const renderEmailTypography = (tooltip) => {
    if (tooltip) {
      return (
        <CustomTooltip title={email}>
          <Typography
            variant="body1"
            noWrap
            color={lightPalette.shoeWax.darker}
            className={classes.emailTypography}
          >
            {email}
          </Typography>
        </CustomTooltip>
      );
    }
    return (
      <Typography
        variant="body1"
        noWrap
        color={lightPalette.shoeWax.darker}
        className={classes.emailTypography}
      >
        {email}
      </Typography>
    );
  };

  const renderModelMenuItems = (models, selectedValue) => {
    if (models?.length >= 0) {
      return models?.map((list) => (
        <MenuItem
          disabled={list?.short_desc === 'custom'}
          value={list?.short_desc || selectedValue}
          key={list?.id}
        >
          {list?.short_desc}
        </MenuItem>
      ));
    }
    return (
      <MenuItem value={selectedValue} key="model">
        {selectedValue}
      </MenuItem>
    );
  };

  let paymentValue = 0;
  if (payment && payment.remaining_credits && payment.used_credits) {
    paymentValue = (payment.used_credits * 100) / payment.remaining_credits;
  }

  const getDisplayPayment = (field) => {
    let displayPayment = ' - - ';
    if (payment[field]) {
      displayPayment = ` ${payment[field]} `;
    }
    return displayPayment;
  };

  const handleApiKey = async (event) => {
    setSelectedApiKey(event.target.value);
    setOpenKeyNameForm(true);
  };

  const openKeyGenerationForm = () => {
    setOpenKeyNameForm(true);
    setSelectedApiKey('');
  };

  const handleDownloadSecretKey = async (apiKeys) => {
    if (apiKeys) {
      const secretKey = await getSecretKey(apiKeys);
      if (!secretKey?.is_downloaded) {
        const element = document.createElement('a');
        if (secretKey?.secret_key) {
          const file = new Blob([secretKey?.secret_key], {
            type: 'text/plain',
          });
          element.href = URL.createObjectURL(file);
          element.download = 'secret_key.txt';
          document.body.appendChild(element);
          element.click();
          updateIsDownloadStatus(true, secretKey);
        }
      } else {
        const downloadBy = await getMemberById(secretKey?.downloaded_by);
        if (userDetail?.email === downloadBy?.email) {
          Toast({
            message: SETTING.SECRET_KEY_DOWNLOAD_ALREADY,
            variant: 'info',
          });
        } else {
          Toast({
            message: `${SETTING.API_SECRET_KEY.ALREADY_DOWNLOAD} ${downloadBy?.email}`,
            variant: 'info',
          });
        }
      }
    } else {
      Toast({
        message: `${SETTING.API_SECRET_KEY.KEY_SELECTION}`,
        variant: 'warning',
      });
    }
  };

  const handleApiResponse = async (responseData) => {
    setApiResponseData(responseData);
  };

  const handleConfirmAction = async (key) => {
    await deleteKeys(key);
    setSelectedApiKey('');
    const remainingKeys = await listOfApiKeys();
    setApiKeyList(remainingKeys?.allKeys);
    setIsOpen(false);
    setOpenKeyNameForm(false);
  };
  const updateClientName = async (payload) => {
    const result = await updateClient(payload);
    if (result) {
      const remainingKeys = await listOfApiKeys();
      setApiKeyList(remainingKeys?.allKeys);
      setOpenKeyNameForm(false);
    }
  };

  const handleOpenDialog = (e) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  const handleCloseDialog = (e) => {
    e.stopPropagation();
    setIsOpen(false);
  };

  const handleDuplicateDocument = async (event) => {
    setDuplicateDocument(event.target.value);
    await updateDocumentDuplication(event.target.value);
  };

  const handleDuplicateDocumentDetails = async (event) => {
    setDuplicateDocumentDetails(event.target.value);
    await updateDocumentDetailsDuplication(event.target.value);
  };
  const handleParentTabChange = (value) => {
    setCurrentParentTab(value);
  };
  const breadcrumbsLinks = [
    {
      label: (
        <>
          {' '}
          <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
        </>
      ),
      link: '/contacts',
    },
    { label: 'Invoice Setting', link: '/settings' },
  ];
  const handleZohoAndQuickBooksCallback = async () => {
    const baseUrl = THIRD_PARTY_REDIRECT_URL_URL_FOR_MANUAL_SETTINGS;

    const handleRedirect = (url) => {
      window.location.href = url;
    };

    const handleTokenExchange = async (tokenData, label) => {
      let newCredential;
      if (tokenData?.email) {
        if (label === 'Zoho') {
          const {
            email,
            refresh_token: refreshToken,
            scope,
            api_domain: apiDomain,
          } = tokenData;
          newCredential = {
            label,
            credential: {
              email,
              refresh_token: refreshToken,
              scope,
              apiDomain,
            },
          };
        } else {
          newCredential = {
            label,
            credential: tokenData,
          };
        }
        setCredentialData(newCredential);
        const credential = await createManualAuthCredential(
          newCredential,
          false,
          displayNameFromSessionStorage,
        );
        if (credential) {
          setExportType(label);
          navigate('/settings');
          setCredentialId(credential?.id);
          setOpenTaxPopup(true);
        }
      } else {
        Toast({ message: `${tokenData?.message}`, variant: 'error' });
      }
    };

    if (code) {
      if (!realmId) {
        if (states) {
          handleRedirect(`${baseUrl}/${states}?code=${code}`);
        } else if (exportOptionFromSessionStorage === 'Xero') {
          const tokenData = await tokenExchangeForXero(
            code,
            'Manual',
            'settings',
          );
          if (tokenData) {
            sessionStorage.removeItem('exportOption');
            await handleTokenExchange(tokenData, 'Xero');
          }
        } else {
          const tokenData = await tokenExchange(code, 'Manual', 'settings');
          if (tokenData) {
            sessionStorage.removeItem('exportOption');
            await handleTokenExchange(tokenData, 'Zoho');
          }
        }
      } else {
        const tokenData = await tokenExchangeForQB(code, realmId, 'settings');
        await handleTokenExchange(tokenData, 'QuickBook');
      }
    }
  };

  useEffect(() => {
    handleZohoAndQuickBooksCallback();
  }, [code]);
  const handleGoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      const codes = tokenResponse.code;

      try {
        const result = await getAllGoogleToken(codes);
        if (result) {
          const userEmail = result.username;
          const newCredential = {
            label: 'Gmail',
            credential: {
              token: result.accessToken,
              email: userEmail,
              refreshToken: result.refreshToken,
              expireDate: result.expireDate,
            },
          };
          const credential = await createManualAuthCredential(
            newCredential,
            false,
          );
          if (credential) {
            const updatedCredentials = await listOfCredentials(userDetail.id);
            setCredentials(updatedCredentials.credential);
            setSelectedTab('Gmail');
          }
        }
      } catch (error) {
        console.error('Error while fetching user info from Google:', error);
      }
    },
    onFailure: (error) => {
      console.error('Google login failed:', error);
    },
    access_type: 'offline',
    prompt: 'consent',
    flow: 'auth-code',
    scope: 'https://www.googleapis.com/auth/gmail.readonly',
  });
  const handleGoogleDriveLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      const codes = tokenResponse.code;

      try {
        const result = await getAllGoogleToken(codes);
        if (result) {
          const selectedFolder = await googleDriveFolderPath(
            result.accessToken,
          );
          if (selectedFolder) {
            const userEmail = result.username;
            const newCredential = {
              label: 'GoogleDrive',
              credential: {
                token: result.accessToken,
                email: userEmail,
                refreshToken: result.refreshToken,
                expireDate: result.expireDate,
                folderSelection: selectedFolder,
              },
            };
            const credential = await createManualAuthCredential(
              newCredential,
              false,
            );
            if (credential) {
              const updatedCredentials = await listOfCredentials(userDetail.id);
              setCredentials(updatedCredentials.credential);
              setSelectedTab('GoogleDrive');
            }
          }
        }
      } catch (error) {
        console.error('Error while fetching user info from Google:', error);
      }
    },
    onFailure: (error) => {
      console.error('Google login failed:', error);
    },
    access_type: 'offline',
    prompt: 'consent',
    flow: 'auth-code',
    scope: 'https://www.googleapis.com/auth/drive.readonly',
  });
  const { instance } = useMsal();
  const authHandlerForMicrosoft = async () => {
    const result = await openAuthenticationEmailPicker({ instance });
    if (!result) {
      return;
    }

    const { accessTokenFromMicrosoft, accountEmailId } = result;

    if (!accessTokenFromMicrosoft || !accountEmailId) {
      return;
    }
    const newCredential = {
      label: 'Outlook',
      credential: {
        token: accessTokenFromMicrosoft,
        email: accountEmailId,
      },
    };
    const credential = await createManualAuthCredential(newCredential, false);
    if (credential) {
      const updatedCredentials = await listOfCredentials(userDetail.id);
      setCredentials(updatedCredentials.credential);
      setSelectedTab('Outlook');
    }
  };
  const openCredentialPopup = async (selectedIconForAddAccount) => {
    const typeHandlers = {
      Xero: async () => {
        const responseUrl = await xeroAuthentication('Manual', 'settings');
        if (responseUrl) {
          sessionStorage.setItem('exportOption', selectedIconForAddAccount);
          window.location.href = `${responseUrl.url}`;
        }
      },
      Zoho: async () => {
        const responseUrl = await zohoAuthentication('Manual', 'settings');
        if (responseUrl) {
          sessionStorage.setItem('exportOption', selectedIconForAddAccount);
          window.location.href = `${responseUrl.url}`;
        }
      },
      QuickBook: () => {
        const { scope } = exportQB;
        const redirectURL = THIRD_PARTY_REDIRECT_URL_URL_FOR_MANUAL_SETTINGS;
        const generateUniqueId = () =>
          `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
        const authUri = `https://appcenter.intuit.com/connect/oauth2?client_id=${QB_CLIENT_ID}&response_type=code&redirect_uri=${encodeURIComponent(redirectURL)}&scope=${encodeURIComponent(scope)}&state=${generateUniqueId()}`;
        window.open(authUri, '_self');
      },
      Odoo: () => {
        setIsCredentialPopup(selectedIconForAddAccount);
      },
      TallyPrime: () => {
        setIsCredentialPopup(selectedIconForAddAccount);
      },
      Gmail: () => {
        handleGoogleLogin();
      },
      Outlook: () => {
        authHandlerForMicrosoft();
      },
      GoogleDrive: () => {
        handleGoogleDriveLogin();
      },
    };

    const handler = typeHandlers[selectedIconForAddAccount];
    if (handler) {
      await handler();
    }
  };
  const updateCredential = async (id) => {
    try {
      const response = await getCredentialsById(id);
      if (response) {
        setIsCredentialPopup(response.type);
        setCurrentData(response);
        setIsEditing(true);
        setExportType(response.type);
        if (
          response.type === 'Xero' ||
          response.type === 'QuickBook' ||
          response.type === 'Zoho'
        ) {
          setCredentialId(response?.id);
          setOpenTaxPopup(true);
        }
      }
    } catch (error) {
      console.log('ERROR', error);
    }
  };
  const closeCredentialPopup = () => {
    setIsCredentialPopup(null);
    setIsEditing(false);
    setOpenTaxPopup(false);
    setCurrentData('');
    setCredentialId(null);
  };
  return (
    <Root className={classes.root}>
      {isLoading ? (
        <Box className={classes.loaderBox}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container className={classes.mainGridContainer}>
          <DynamicTabLayout
            navItems={TabData}
            navLinks={breadcrumbsLinks}
            showBreadcrumbs={false}
            onTabChange={handleParentTabChange}
          >
            <Box className={classes.generalGrid} index="General">
              <Typography variant="body2" className={classes.headingText}>
                Manage the information you select and store about your needs.
              </Typography>
              <Divider variant="fullWidth" className={classes.divider} />
              <Box container className={classes.accountDetailGrid}>
                <Grid item className={classes.labelDescription}>
                  <Typography
                    variant="h5"
                    className={classes.invoiceSettingHeadings}
                  >
                    {SETTING.ACCOUNT}
                  </Typography>
                  <Typography variant="h5" className={classes.accountName}>
                    {name}
                    {renderEmailTypography(showTooltip)}
                  </Typography>
                </Grid>
                <Grid item>
                  <Box className={classes.labelDescription}>
                    <Typography
                      variant="h5"
                      color={lightPalette.darkPurple.main}
                    >
                      {SETTING.MODEL}
                    </Typography>
                    <FormControl
                      className={classes.invoiceSettingModelFormControl}
                    >
                      <Select
                        disabled={role !== ROLES.ADMIN}
                        size="small"
                        value={selectedModel}
                        onChange={handleModel}
                      >
                        {renderModelMenuItems(model, selectedModel)}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
              </Box>
              <Divider variant="fullWidth" className={classes.divider} />
              {role === ROLES.ADMIN ? (
                <Box container className={classes.apiKeyGrid}>
                  <Grid item className={classes.ApilabelDescription}>
                    <Typography
                      variant="h5"
                      className={classes.invoiceSettingHeadings}
                    >
                      {SETTING.API_KEY}
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.descriptionWidth}
                    >
                      {SETTING.API_KEY_DESCRIPTION}
                    </Typography>
                  </Grid>
                  <Grid item className={classes.ApiDropDownlabelDescription}>
                    <Grid container direction="column">
                      {apiKeyList.length > 0 ? (
                        <Grid item xs={6}>
                          <Grid container>
                            <Grid item xs={3}>
                              <CustomFormControl>
                                <SelectKeyMenu
                                  size="small"
                                  value={
                                    selectedApiKey?.name?.substring(0, 5) || ''
                                  }
                                  onChange={handleApiKey}
                                  renderValue={() => {
                                    if (
                                      !selectedApiKey?.name ||
                                      selectedApiKey?.name?.length === 0
                                    ) {
                                      return (
                                        <Typography variant="body1">
                                          {API_KEY.SELECTION_PLACEHOLDER}
                                        </Typography>
                                      );
                                    }
                                    return selectedApiKey?.name;
                                  }}
                                  displayEmpty
                                  MenuProps={StyledMenuProps}
                                >
                                  {apiKeyList?.length >= 0 &&
                                    apiKeyList?.map((apiKey) => (
                                      <CustomMenuItem
                                        value={apiKey}
                                        key={apiKey?.id}
                                      >
                                        <MenuItemBox>
                                          <CustomTooltip title={apiKey?.name}>
                                            <Typography>
                                              {apiKey?.name}
                                            </Typography>
                                          </CustomTooltip>
                                        </MenuItemBox>
                                      </CustomMenuItem>
                                    ))}
                                </SelectKeyMenu>
                              </CustomFormControl>
                            </Grid>

                            {isOpen && (
                              <ConfirmDialog
                                open={isOpen}
                                onClose={(e) => handleCloseDialog(e)}
                                onConfirm={() =>
                                  handleConfirmAction(selectedApiKey?.api_key)
                                }
                                askingMessage={
                                  SETTING.API_SECRET_KEY.ASKING_MESSAGE
                                }
                              />
                            )}

                            <Grid item xs={6}>
                              <Grid container>
                                <Grid item xs={6}>
                                  <Button
                                    variant="contained"
                                    onClick={openKeyGenerationForm}
                                    className={classes.generateKeyButton}
                                  >
                                    <Typography
                                      variant="body1"
                                      color={lightPalette.secondaryWhite.main}
                                    >
                                      {API_KEY.ADD_MORE_KEY}
                                    </Typography>
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      ) : (
                        <Button
                          variant="contained"
                          onClick={openKeyGenerationForm}
                          className={classes.generateKeyButtonWithoutKey}
                        >
                          <Typography
                            variant="body1"
                            color={lightPalette.secondaryWhite.main}
                          >
                            {API_KEY.GENERATE_KEY}
                          </Typography>
                        </Button>
                      )}
                      {openKeyNameForm && (
                        <Backdrop
                          className={classes.openKeyGenerationFormBackdrop}
                          open={openKeyNameForm}
                        >
                          <KeyNameForm
                            setOpenKeyNameForm={setOpenKeyNameForm}
                            handleApiResponse={handleApiResponse}
                            selectedApiKey={selectedApiKey?.api_key}
                            selectedApiName={selectedApiKey?.name}
                            handleDownloadSecretKey={handleDownloadSecretKey}
                            handleOpenDialog={handleOpenDialog}
                            setSelectedApiKey={setSelectedApiKey}
                            clientId={selectedApiKey?.client_id}
                            updateClientName={updateClientName}
                          />
                        </Backdrop>
                      )}

                      <Grid item xs={6} paddingTop={2}>
                        <LinearProgress
                          variant="determinate"
                          value={paymentValue}
                          className={classes.linearProgress}
                        />
                        <Typography
                          variant="subtitle1"
                          component="p"
                          className={classes.creditDetails}
                        >
                          {getDisplayPayment('remaining_credits')}
                          of {getDisplayPayment('total_credits')}
                          credits remaining
                        </Typography>

                        <Typography
                          variant="subtitle1"
                          component="p"
                          className={classes.expiryDate}
                        >
                          Expires
                          {expiryDate}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              ) : (
                <Grid item xs={6} paddingTop={2}>
                  <LinearProgress
                    variant="determinate"
                    value={paymentValue}
                    className={classes.linearProgress}
                  />
                  <Typography
                    variant="subtitle1"
                    component="p"
                    className={classes.creditDetails}
                  >
                    {getDisplayPayment('remaining_credits')}
                    of {getDisplayPayment('total_credit')}
                    credits remaining
                  </Typography>

                  <Typography
                    variant="subtitle1"
                    component="p"
                    className={classes.expiryDate}
                  >
                    Expires
                    {expiryDate}
                  </Typography>
                </Grid>
              )}
              <Divider variant="fullWidth" className={classes.divider} />
              <Box container className={classes.documentSection}>
                <Box className={classes.leftSection}>
                  <Box>
                    <Typography
                      variant="h5"
                      className={classes.invoiceSettingHeadings}
                    >
                      {SETTING.DOCUMENT_HANDLING}
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.descriptionWidth}
                    >
                      {role === ROLES.ADMIN
                        ? SETTING.DOCUMENT_HANDLING_DESCRIPTION
                        : SETTING.DOCUMENT_HANDLING_DESCRIPTION_FOR_USERS}
                    </Typography>
                  </Box>
                  <Box>
                    <CustomFormControl>
                      <SelectDuplicateDocumentMenu
                        size="small"
                        value={duplicateDocument}
                        onChange={handleDuplicateDocument}
                        displayEmpty
                        MenuProps={StyledMenuProps}
                        disabled={role !== ROLES.ADMIN}
                      >
                        {duplicateDocumentMenuItems?.length >= 0 &&
                          duplicateDocumentMenuItems?.map((document, index) => (
                            <CustomMenuItem
                              value={document}
                              key={`${index + 1} document`}
                            >
                              <MenuItemBox>{document}</MenuItemBox>
                            </CustomMenuItem>
                          ))}
                      </SelectDuplicateDocumentMenu>
                    </CustomFormControl>
                  </Box>
                </Box>
                <Box className={classes.rightSection}>
                  <Box>
                    <Typography
                      variant="h5"
                      className={classes.invoiceSettingHeadings}
                    >
                      {SETTING.DOCUMENT_DETAILS_HANDLING}
                    </Typography>
                    <Typography
                      variant="body2"
                      className={classes.descriptionWidth}
                    >
                      {role === ROLES.ADMIN
                        ? SETTING.DOCUMENT_HANDLING_DESCRIPTION
                        : SETTING.DOCUMENT_HANDLING_DESCRIPTION_FOR_USERS}
                    </Typography>
                  </Box>
                  <Box>
                    <CustomFormControl>
                      <SelectDuplicateDocumentMenu
                        size="small"
                        value={duplicateDocumentDetails}
                        onChange={handleDuplicateDocumentDetails}
                        displayEmpty
                        MenuProps={StyledMenuProps}
                        disabled={role !== ROLES.ADMIN}
                      >
                        {duplicateDocumentMenuItems?.length >= 0 &&
                          duplicateDocumentMenuItems?.map((document, index) => (
                            <CustomMenuItem
                              value={document}
                              key={`${index + 1} document`}
                            >
                              <MenuItemBox>{document}</MenuItemBox>
                            </CustomMenuItem>
                          ))}
                      </SelectDuplicateDocumentMenu>
                    </CustomFormControl>
                  </Box>
                </Box>
              </Box>
              <Divider variant="fullWidth" className={classes.divider} />

              {role === ROLES.ADMIN && (
                <Grid container className={classes.apiKeyGrid}>
                  <Grid
                    item
                    xs={4}
                    sm={5}
                    md={5}
                    lg={4}
                    xl={5}
                    xxl={4}
                    className={classes.labelDescription}
                  >
                    <Typography
                      variant="h5"
                      className={classes.invoiceSettingHeadings}
                    >
                      {SETTING.ALLOW_MANAGERS}
                    </Typography>
                  </Grid>
                  <Grid item xs={8} sm={7} md={7} lg={8} xl={7} xxl={8}>
                    <SelectTagAutoComplete
                      multiple
                      id="checkboxes-tags-demo"
                      options={managers}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option.title}
                      value={selectedManagers}
                      onChange={handleSelectionChange}
                      renderOption={(item, option, { selected }) => {
                        const { key, ...optionProps } = item;
                        return (
                          <li key={key} {...optionProps}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 3 }}
                              checked={selected}
                            />
                            {option.title}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Managers"
                          size="small"
                          placeholder="Favorites"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              )}
            </Box>
            <Grid index="Credentials" container className={classes.apiKeyGrid}>
              <Typography variant="body2" className={classes.headingText}>
                Manage and Update credential.
              </Typography>
              <Divider variant="fullWidth" className={classes.divider} />
              <Grid className={classes.labelDescription} sx={{ width: '100%' }}>
                <DynamicTabLayout
                  navItems={CredentialSideBarMenu}
                  navLinks={breadcrumbsLinks}
                  showBreadcrumbs={false}
                  orientation="vertical"
                  isVertical={isTabVertial}
                  onTabChange={handleChange}
                >
                  <Box index="Gmail" pl={4} className={classes.subTabComponent}>
                    <Box className={classes.addCredentialButton}>
                      <Button
                        variant="outlined"
                        className={classes.addButton}
                        onClick={() => {
                          openCredentialPopup('Gmail');
                        }}
                      >
                        + Add Credential
                      </Button>
                    </Box>
                    {selectedCredential.length > 0 &&
                      selectedCredential.map((elem, index) => (
                        <Grid item pb={2} key={index}>
                          <CardComponent
                            Icon={GmailIcon}
                            credential={elem.credential}
                            type={elem.type}
                            displayName={
                              elem.display_name ? elem.display_name : '--'
                            }
                            taxMapping={
                              elem.tax_mapping ? elem.tax_mapping : []
                            }
                            id={elem.id}
                            handleDeleteCredential={handleDeleteCredential}
                            handleUpdate={updateCredential}
                          />
                        </Grid>
                      ))}
                  </Box>
                  <Box
                    index="One Drive"
                    pl={4}
                    className={classes.subTabComponent}
                  >
                    <Box className={classes.addCredentialButton}>
                      <Button
                        variant="outlined"
                        className={classes.addButton}
                        onClick={() => {
                          openCredentialPopup('OneDrive');
                        }}
                      >
                        + Add Credential
                      </Button>
                    </Box>
                    {selectedCredential.length > 0 &&
                      selectedCredential.map((elem, index) => (
                        <Grid item pb={2} key={index}>
                          <CardComponent
                            Icon={OneDriveIcon}
                            credential={elem.credential}
                            type={elem.type}
                            displayName={
                              elem.display_name ? elem.display_name : '--'
                            }
                            taxMapping={
                              elem.tax_mapping ? elem.tax_mapping : []
                            }
                            id={elem.id}
                            handleDeleteCredential={handleDeleteCredential}
                            handleUpdate={updateCredential}
                          />
                        </Grid>
                      ))}
                  </Box>
                  <Box
                    index="Google Drive"
                    pl={4}
                    className={classes.subTabComponent}
                  >
                    <Box className={classes.addCredentialButton}>
                      <Button
                        variant="outlined"
                        className={classes.addButton}
                        onClick={() => {
                          openCredentialPopup('GoogleDrive');
                        }}
                      >
                        + Add Credential
                      </Button>
                    </Box>
                    {selectedCredential.length > 0 &&
                      selectedCredential.map((elem, index) => (
                        <Grid item pb={2} key={index}>
                          <CardComponent
                            Icon={GoogleDriveIcon}
                            credential={elem.credential}
                            type={elem.type}
                            displayName={
                              elem.display_name ? elem.display_name : '--'
                            }
                            taxMapping={
                              elem.tax_mapping ? elem.tax_mapping : []
                            }
                            id={elem.id}
                            handleDeleteCredential={handleDeleteCredential}
                            handleUpdate={updateCredential}
                          />
                        </Grid>
                      ))}
                  </Box>
                  <Box
                    index="Outlook"
                    pl={4}
                    className={classes.subTabComponent}
                  >
                    <Box className={classes.addCredentialButton}>
                      <Button
                        variant="outlined"
                        className={classes.addButton}
                        onClick={() => {
                          openCredentialPopup('Outlook');
                        }}
                      >
                        + Add Credential
                      </Button>
                    </Box>
                    {selectedCredential.length > 0 &&
                      selectedCredential.map((elem, index) => (
                        <Grid item pb={2} key={index}>
                          <CardComponent
                            Icon={OutlookIcon}
                            credential={elem.credential}
                            type={elem.type}
                            displayName={
                              elem.display_name ? elem.display_name : '--'
                            }
                            taxMapping={
                              elem.tax_mapping ? elem.tax_mapping : []
                            }
                            id={elem.id}
                            handleDeleteCredential={handleDeleteCredential}
                            handleUpdate={updateCredential}
                          />
                        </Grid>
                      ))}
                  </Box>
                  <Box
                    index="SharePoint"
                    pl={4}
                    className={classes.subTabComponent}
                  >
                    <Box className={classes.addCredentialButton}>
                      <Button
                        variant="outlined"
                        className={classes.addButton}
                        onClick={() => {
                          openCredentialPopup('SharePoint');
                        }}
                      >
                        + Add Credential
                      </Button>
                    </Box>
                    {selectedCredential.length > 0 &&
                      selectedCredential.map((elem, index) => (
                        <Grid item pb={2} key={index}>
                          <CardComponent
                            Icon={SharePointIcon}
                            credential={elem.credential}
                            type={elem.type}
                            displayName={
                              elem.display_name ? elem.display_name : '--'
                            }
                            taxMapping={
                              elem.tax_mapping ? elem.tax_mapping : []
                            }
                            id={elem.id}
                            handleDeleteCredential={handleDeleteCredential}
                            handleUpdate={updateCredential}
                          />
                        </Grid>
                      ))}
                  </Box>
                  <Box
                    index="Tally Prime"
                    pl={4}
                    className={classes.subTabComponent}
                  >
                    <Box className={classes.addCredentialButton}>
                      <Button
                        variant="outlined"
                        className={classes.addButton}
                        onClick={() => {
                          openCredentialPopup('TallyPrime');
                        }}
                      >
                        + Add Credential
                      </Button>
                    </Box>
                    {selectedCredential.length > 0 ? (
                      selectedCredential.map((elem, index) => (
                        <Grid item pb={2} key={index}>
                          <CardComponent
                            Icon={Tally}
                            credential={elem.credential}
                            type={elem.type}
                            displayName={
                              elem.display_name ? elem.display_name : '--'
                            }
                            taxMapping={
                              elem.tax_mapping ? elem.tax_mapping : []
                            }
                            id={elem.id}
                            handleDeleteCredential={handleDeleteCredential}
                            handleUpdate={updateCredential}
                          />
                        </Grid>
                      ))
                    ) : (
                      <Box
                        display="flex"
                        flex={1}
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Typography>
                          No Credentials Found Kindly Create New One
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  <Box index="Odoo" pl={4} className={classes.subTabComponent}>
                    <Box className={classes.addCredentialButton}>
                      <Button
                        variant="outlined"
                        className={classes.addButton}
                        onClick={() => {
                          openCredentialPopup('Odoo');
                        }}
                      >
                        + Add Credential
                      </Button>
                    </Box>
                    {selectedCredential.length > 0 ? (
                      selectedCredential.map((elem, index) => (
                        <Grid item pb={2} key={index}>
                          <CardComponent
                            Icon={Odoo}
                            credential={elem.credential}
                            type={elem.type}
                            displayName={
                              elem.display_name ? elem.display_name : '--'
                            }
                            taxMapping={
                              elem.tax_mapping ? elem.tax_mapping : []
                            }
                            id={elem.id}
                            handleDeleteCredential={handleDeleteCredential}
                            handleUpdate={updateCredential}
                          />
                        </Grid>
                      ))
                    ) : (
                      <Box
                        display="flex"
                        flex={1}
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Typography>
                          No Credentials Found Kindly Create New One
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  <Box index="Zoho" pl={4} className={classes.subTabComponent}>
                    <Box className={classes.addCredentialButton}>
                      <Button
                        variant="outlined"
                        className={classes.addButton}
                        onClick={() => {
                          addAccountDisplayName();
                        }}
                      >
                        + Add Credential
                      </Button>
                    </Box>
                    {selectedCredential.length > 0 ? (
                      selectedCredential.map((elem, index) => (
                        <Grid item pb={2} key={index}>
                          <CardComponent
                            Icon={Zoho}
                            credential={elem.credential}
                            type={elem.type}
                            displayName={
                              elem.display_name ? elem.display_name : '--'
                            }
                            taxMapping={
                              elem.tax_mapping ? elem.tax_mapping : []
                            }
                            id={elem.id}
                            handleDeleteCredential={handleDeleteCredential}
                            handleUpdate={updateCredential}
                          />
                        </Grid>
                      ))
                    ) : (
                      <Box
                        display="flex"
                        flex={1}
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Typography>
                          No Credentials Found Kindly Create New One
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  <Box
                    index="QuickBook"
                    pl={4}
                    className={classes.subTabComponent}
                  >
                    <Box className={classes.addCredentialButton}>
                      <Button
                        variant="outlined"
                        className={classes.addButton}
                        onClick={() => {
                          addAccountDisplayName();
                        }}
                      >
                        + Add Credential
                      </Button>
                    </Box>
                    {selectedCredential.length > 0 ? (
                      selectedCredential.map((elem, index) => (
                        <Grid item pb={2} key={index}>
                          <CardComponent
                            Icon={QuickBook}
                            credential={elem.credential}
                            type={elem.type}
                            displayName={
                              elem.display_name ? elem.display_name : '--'
                            }
                            taxMapping={
                              elem.tax_mapping ? elem.tax_mapping : []
                            }
                            id={elem.id}
                            handleDeleteCredential={handleDeleteCredential}
                            handleUpdate={updateCredential}
                          />
                        </Grid>
                      ))
                    ) : (
                      <Box
                        display="flex"
                        flex={1}
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Typography>
                          No Credentials Found Kindly Create New One
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  <Box index="Xero" pl={4} className={classes.subTabComponent}>
                    <Box className={classes.addCredentialButton}>
                      <Button
                        variant="outlined"
                        className={classes.addButton}
                        onClick={() => {
                          addAccountDisplayName();
                        }}
                      >
                        + Add Credential
                      </Button>
                    </Box>
                    {selectedCredential.length > 0 &&
                      selectedCredential.map((elem, index) => (
                        <Grid item pb={2} key={index}>
                          <CardComponent
                            Icon={Xero}
                            credential={elem.credential}
                            type={elem.type}
                            displayName={
                              elem.display_name ? elem.display_name : '--'
                            }
                            taxMapping={
                              elem.tax_mapping ? elem.tax_mapping : []
                            }
                            id={elem.id}
                            handleDeleteCredential={handleDeleteCredential}
                            handleUpdate={updateCredential}
                          />
                        </Grid>
                      ))}
                  </Box>
                </DynamicTabLayout>
              </Grid>
            </Grid>
            <Grid index="Data Field" container className={classes.apiKeyGrid}>
              <Typography variant="body2" className={classes.headingText}>
                Select the field that should be extracted.
              </Typography>
              <Divider variant="fullWidth" className={classes.divider} />
              <Grid className={classes.labelDescription} sx={{ width: '100%' }}>
                <DynamicTabLayout
                  navItems={tabs}
                  navLinks={breadcrumbsLinks}
                  showBreadcrumbs={false}
                  orientation="vertical"
                  isVertical={isTabVertial}
                >
                  <Box
                    index="Bank Statement"
                    pl={4}
                    className={classes.subTabComponent}
                  >
                    <DataFields documentType="bs_field" />
                  </Box>
                  <Box
                    index="Credit Card Statement"
                    pl={4}
                    className={classes.subTabComponent}
                  >
                    <DataFields documentType="cc_field" />
                  </Box>
                  <Box index="Sales" pl={4} className={classes.subTabComponent}>
                    <DataFields documentType="sales_field" />
                  </Box>
                  <Box
                    index="Direct Expenses"
                    pl={4}
                    className={classes.subTabComponent}
                  >
                    <DataFields documentType="invoice_field" />
                  </Box>
                  <Box
                    index="Indirect Expenses"
                    pl={4}
                    className={classes.subTabComponent}
                  >
                    <DataFields documentType="receipt_field" />
                  </Box>
                </DynamicTabLayout>
              </Grid>
            </Grid>
          </DynamicTabLayout>
        </Grid>
      )}
      {isOpenCredentialPopup === 'TallyPrime' && (
        <TallyPrimeForm
          tallyForm={isOpenCredentialPopup === 'TallyPrime'}
          closeTallyForm={closeCredentialPopup}
          isSetting={isSetting}
          isManual={isManual}
          currentData={currentData}
          isEditing={isEditing}
          setCurrentData={setCurrentData}
          setIsEditing={setIsEditing}
        />
      )}
      {isOpenCredentialPopup === 'Odoo' && (
        <OdooForm
          odooForm={isOpenCredentialPopup === 'Odoo'}
          closeOdooForm={closeCredentialPopup}
          isSetting={isSetting}
          isManual={isManual}
          currentData={currentData}
          isEditing={isEditing}
          setCurrentData={setCurrentData}
          setIsEditing={setIsEditing}
        />
      )}

      {openTaxPopup && (
        <TaxMapping
          exportType={exportType}
          credentialId={credentialId}
          handleNewAndExport={() => {}}
          newCredential={credentialData}
          isManual={isManual}
          documentExportFunc={() => {}}
          openTaxPopup={openTaxPopup}
          closePopup={closeCredentialPopup}
          isSetting={isSetting}
          currentData={currentData}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
      )}

      <DisplayNamePopUp
        open={openDisplayNamePopup}
        handleClose={handleDisplayNamePopupClose}
        setDisplayName={setDisplayName}
        displayName={displayName}
        displayNameRequiredError={displayNameRequiredError}
        setDisplayNameRequiredError={setDisplayNameRequiredError}
        addAccountHandler={openCredentialPopup}
        selectedIcon={selectedTab}
      />
    </Root>
  );
};

export default Setting;
